import React from "react";
import Home from "../../components/Home";
import LogoutHeader from '../../components/Headers/LogoutHeader';
import LogoutFooter from '../../components/Footers/LogoutFooter';
import classes from "./index.module.scss";

const HomePage = () => {
  return (
    <div className={classes.HomePage}>
      <LogoutHeader />
      <main>
        <Home />
      </main>
      <LogoutFooter />
    </div>
  );
};

export default HomePage;